import React from 'react';
import { NavLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { useTranslation } from 'react-i18next';
import enTexts from './NavbarEn.json';
import deTexts from './NavbarDe.json';
import styles from './Navbar.module.css';

function Navbar() {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    const texts = currentLang.startsWith('de') ? deTexts : enTexts;

    const toggleLanguage = () => {
        const newLang = i18n.language.startsWith('en') ? 'de' : 'en';
        i18n.changeLanguage(newLang);
    };

    return (
        <nav className={styles.navbar}>
            <ul className={styles.navList}>
                <li className={styles.navItem}>
                    <NavLink
                        to="/"
                        className={({isActive}) => (isActive ? styles.active : '')}
                    >
                        {texts.navbar_profil}
                    </NavLink>
                </li>
                <li className={`${styles.navItem} ${styles.dropdownContainer}`}>
                    <NavLink
                        to="/projekte"
                        className={({isActive}) => (isActive ? styles.active : '')}
                    >
                        {texts.navbar_projects}
                    </NavLink>
                    <ul className={styles.dropdown}>
                        <li>
                            <HashLink smooth to="/projekte#crossInnovation">Cross Innovation</HashLink>
                        </li>
                        <li>
                            <HashLink smooth to="/projekte#dynamicClock">Dynamic Clock</HashLink>
                        </li>
                        <li>
                            <HashLink smooth to="/projekte#happyCube">Happy Cube</HashLink>
                        </li>
                        <li>
                            <HashLink smooth to="/projekte#trading">Trading</HashLink>
                        </li>
                    </ul>
                </li>
                <li className={styles.navItem}>
                    <NavLink
                        to="/lebenslauf"
                        className={({isActive}) => (isActive ? styles.active : '')}
                    >
                        {texts.navbar_cv}
                    </NavLink>
                </li>
                <li className={styles.navItem}>
                    <NavLink
                        to="/kontakt"
                        className={({isActive}) => (isActive ? styles.active : '')}
                    >
                        {texts.navbar_contact}
                    </NavLink>
                </li>
                {/* Sprachumschalt-Button */}
                <li className={styles.navItem}>
                    <button
                        onClick={toggleLanguage}
                        className={styles.langButton}
                        title="Sprache wechseln"
                    >
                        {i18n.language.startsWith('en') ? '🇬🇧' : '🇩🇪'}
                    </button>
                </li>
            </ul>
        </nav>
    );
}

export default Navbar;
